import { useNavigate } from "react-router";

import { RiUserFill } from "react-icons/ri";
import { useEffect, useMemo, useRef, useState } from "react";
import useDeviceType from "../../hook/useDeviceType";
import IconCircleWrapper from "../Icon/IconCircleWrapper";
import { BiSolidBellRing } from "react-icons/bi";
import { useSelector } from "react-redux";
import {
  Box,
  Flex,
  Icon,
  Image,
  Text,
  chakra,
  shouldForwardProp,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import { COMMON_WEB_PATH } from "../../constant";

const bellShakeAnimation = {
  rotate: [0, 20, -20, 20, -20, 0],
  transition: {
    duration: 0.5,
    ease: "easeInOut",
    times: [0, 0.2, 0.4, 0.6, 0.8, 1],
    repeat: Infinity,
    repeatDelay: 1,
  },
};

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const SignInDataV2 = ({}) => {
  const deviceType = useDeviceType();

  const inboxList = useSelector((state) => state.isInboxList);

  const navigate = useNavigate();

  const hasUnRead = useMemo(() => {
    return {
      unRead: inboxList?.filter((item) => item.status == "Unread")?.length > 0,
      unReadLength: inboxList?.filter((item) => item.status == "Unread")
        ?.length,
    };
  }, [inboxList]);

  const { unRead, unReadLength } = hasUnRead || {};

  return (
    <Flex alignItems={`center`} gap="15px">
      {/* <IconCircleWrapper
        divProps={{
          onClick: () => navigate("profile/inbox"),
        }}
      >
        {hasUnRead && (
          <Box
            position={`absolute`}
            top={`0px`}
            right={`0px`}
            width={`5px`}
            height={`5px`}
            borderRadius={`full`}
            bg="red"
          ></Box>
        )}
        <ChakraBox
          initial={{ rotate: 0 }}
          animate={hasUnRead && bellShakeAnimation}
          position="relative"
        >
          <BiSolidBellRing className="text-xl" />
        </ChakraBox>
      </IconCircleWrapper> */}
      <Box
        onClick={() => navigate("profile/inbox")}
        position="relative"
        cursor="pointer"
      >
        {!unRead && (
          <Box
            position={`absolute`}
            top={`-2px`}
            right={`-2px`}
            width={`5px`}
            height={`5px`}
            borderRadius={`full`}
            bg="red.500"
            display="flex"
            alignItems={`center`}
            zIndex={2}
            justifyContent={`center`}
          >
            {/* <Text color="#000" fontSize="10px">
              {unReadLength}
            </Text> */}
          </Box>
        )}
        <ChakraBox
          initial={{ rotate: 0 }}
          animate={unRead && bellShakeAnimation}
          position="relative"
        >
          <Icon
            as={BiSolidBellRing}
            fontSize="23px"
            mb="3px"
            color="brand.300"
          />
          {/* <Image
            src={`${COMMON_WEB_PATH}/b69-home/v3-layout-icon/inbox-notice.svg`}
          /> */}
        </ChakraBox>
      </Box>

      {/* <IconCircleWrapper
        divProps={{
          onClick: () => {
            if (deviceType === "Mobile") {
              navigate("profile");
            } else {
              navigate("profile/data");
            }
          },
          display: {
            base: "none",
            md: "flex",
          },
        }}
      >
        <RiUserFill className="text-xl" />
      </IconCircleWrapper> */}
      <Box
        onClick={() => {
          if (deviceType === "Mobile") {
            navigate("profile");
          } else {
            navigate("profile/data");
          }
        }}
        display={{
          base: "none",
          md: "flex",
        }}
        position="relative"
        cursor="pointer"
      >
        <Icon as={RiUserFill} fontSize="23px" mb="3px" color="brand.300" />
      </Box>
    </Flex>
  );
};

export default SignInDataV2;
